import cn from 'classnames';
import Decimal from 'decimal.js';
import { TextField, Select, MenuItem, Typography, CloseButton } from 'seagull';
import { StagesTerms } from "../../../models";
import { utils } from "../../../utils";
import styles from "./BillingStagesSelect.module.scss";
import { getHelperText, valueTypeTextMap, isValueTypePercent, isValueTypeDollars } from "./BillingStagesSelect.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Stage = _ref => {
  let {
    index,
    stage,
    isLast,
    isFirst,
    discount,
    totalRate,
    isAmendment,
    effectiveDate,
    disabledReason,
    stageClassName,
    discountedTotalRate,
    totalSumExceedsRate,
    oneTimeInStagesBilling,
    onRemove,
    onChange: _onChange,
    onValueTypeChange
  } = _ref;
  const valueType = oneTimeInStagesBilling.valueType();
  const helperText = getHelperText(stage, isLast, valueType, totalRate, totalSumExceedsRate);
  const stagedBillingBehaviour = oneTimeInStagesBilling.terms();
  const width = 216;
  const getAutomaticBillingText = () => "automatically ".concat(isAmendment ? 'when amendments are saved' : "on ".concat(effectiveDate ? 'agreement effective date' : 'agreement approval'));
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.stage, stageClassName),
    children: [/*#__PURE__*/_jsx(TextField, {
      collapseHelperText: false,
      width: width,
      minWidth: width,
      disableSuffixPadding: true,
      error: !!helperText,
      helperText: helperText,
      alwaysShrinkLabel: true,
      label: "Stage ".concat(stage.stageNumber),
      disabled: isLast || !!disabledReason,
      isMoney: isValueTypeDollars(valueType),
      isPercentage: isValueTypePercent(valueType),
      value: stage.value.toString(),
      testId: "billing-stage-".concat(index),
      onChange: e => {
        _onChange({
          stageNumber: stage.stageNumber,
          value: new Decimal(e.target.value || 0).toDecimalPlaces(2)
        });
      },
      suffix: isFirst ? /*#__PURE__*/_jsx(Select, {
        collapseHelperText: false,
        disabled: !!disabledReason,
        preventOutline: true,
        width: 60,
        minWidth: 60,
        SelectProps: {
          autoWidth: true
        },
        value: valueType,
        testId: "billing-stage-split-by-select",
        onChange: e => {
          const newValueType = e.target.value;
          onValueTypeChange(newValueType);
        },
        children: Object.entries(valueTypeTextMap).map(_ref2 => {
          let [value, text] = _ref2;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: value,
            testId: "billing-stage-split-by-option-".concat(value),
            children: text
          }, value);
        })
      }) : /*#__PURE__*/_jsx(Typography, {
        disabled: !!disabledReason,
        className: styles.valueTypeSelect,
        width: 60,
        minWidth: 60,
        SelectProps: {
          autoWidth: true
        },
        value: valueType,
        testId: "billing-stage-".concat(index, "-split-by"),
        children: valueTypeTextMap[valueType]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.closeButtonContainer,
      children: !isFirst && !isLast && !disabledReason && /*#__PURE__*/_jsx(CloseButton, {
        skin: "transparent",
        testId: "billing-stage-".concat(index, "-remove"),
        onClick: onRemove
      })
    }), /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      className: styles.stageDescription,
      testId: "billing-stage-".concat(index, "-description"),
      children: "".concat(isValueTypeDollars(valueType) ? !discount.isZero() ? utils.formatDollarAmount(stage.value.mul(new Decimal(1).minus(discount.div(100)))) : '' : utils.formatDollarAmount(stage.value.div(100).mul(discountedTotalRate)), " billed ").concat(isFirst && stagedBillingBehaviour === StagesTerms.AutoFirst ? getAutomaticBillingText() : 'manually')
    })]
  });
};